import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "mr0" }
const _hoisted_4 = { class: "calm-badge" }
const _hoisted_5 = { class: "calm-remove-all" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_icon = _resolveComponent("f-icon")!
  const _component_f_button = _resolveComponent("f-button")!
  const _component_AlmFileSelectionSection = _resolveComponent("AlmFileSelectionSection")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.localizer.Localize("LandscapeManagement_Selection")), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.selectedFiles?.length), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_f_button, {
          type: "ghost",
          disabled: _ctx.selectedFiles?.length === 0,
          class: "flex items-center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleFsoChild(false, _ctx.root)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_f_icon, {
              icon: "delete",
              disabled: true,
              class: "theme-svg"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.localizer.Localize("LandscapeManagement_Remove")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createVNode(_component_AlmFileSelectionSection, {
      selectedFiles: _ctx.selectedFiles,
      isReadonly: false,
      onRemoveItem: _ctx.toggleFsoChild
    }, null, 8, ["selectedFiles", "onRemoveItem"])
  ], 64))
}